import { useMatches } from 'react-router-dom';

import type { Handle } from '@remix-run/router';

export const useRouteHandleSection = () => {
  const matches = useMatches();

  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const handle = matches[i].handle as Handle | undefined;
    if (handle?.sections) {
      return { sections: handle.sections };
    }
  }
  return { sections: null };
};
